module.exports = __webpack_public_path__ + "img/nofilter-scfp-dat.a57f93a2.svg";